const data = require("./regionMap.json");

export const getZipcodes = () => {
    var zipList = []
    // data.forEach(obj => {
    for (let i=0; i < data.length; i++) {
        if (data[i] !== zipList[i - 1]) {
             zipList.push(data[i].Zip)
        } i++ }
    return zipList
}  